import type { QueryHookOptions } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";

import type { Product, ProductTaxonomy } from "@shared/types/graphqlGenerated";

const ProductTaxonomies_Emerson_Query = gql`
  query ProductTaxonomies_Emerson_Query($productId: ID!) {
    viewer {
      product: node(id: $productId) {
        ... on Product {
          id

          taxonomies {
            id
            name
            parent {
              id
              name
              parent {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

type ProductSplinter = Pick<Product, "id">;

type TaxonomySplinter = Pick<ProductTaxonomy, "id" | "name" | "parent">;

interface ProductWithTaxonomies extends ProductSplinter {
  taxonomies: TaxonomySplinter[];
}

interface ProductTaxonomiesQueryData {
  viewer: {
    product: ProductWithTaxonomies;
  };
}

interface Variables {
  productId: string;
}

const useProductTaxonomiesQuery = (
  options?: QueryHookOptions<ProductTaxonomiesQueryData, Variables>
) => {
  return useQuery<ProductTaxonomiesQueryData, Variables>(ProductTaxonomies_Emerson_Query, options);
};

export type { ProductTaxonomiesQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useProductTaxonomiesQuery, ProductTaxonomies_Emerson_Query };
